import React from "react";
import PageHead from "../Head";
import News from "@/components/News/News";
import Footer from "@/components/Footer/Footer";
import Context from "@/context/Context";
import Image from "next/image";
import Header from "@/components/Header/Header";
import Copyright from "@/components/Footer/Copyright";
import CallToAction from "@/components/CallToAction/CallToAction";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";
import newsBanner from "../../public/images/banner/banner-news.png";
import Head from "next/head";

const NewsPage = () => {
  return (
    <>
      <PageHead title="News" description={""} />
      <main className="page-wrapper">
        <Context>
          <PopupMobileMenu />
          <Header btnClass="btn-small round" />
          <div className="news-cover-section">
            <div className="container">
              <h1 className="title">Viatick News</h1>
            </div>
            <div className="image-wrapper">
              <Image src={newsBanner} alt="news-cover" height={600} />
            </div>
          </div>
          <News />
          <CallToAction />
          <Footer />
          <Copyright />
        </Context>
      </main>
    </>
  );
};

export default NewsPage;
